

import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Route, Routes,
  Link
} from 'react-router-dom';




import logo from '../logo_b.png'
import logob from '../logob.png'
import logo_black from '../logo_black.png'
import menu_home from '../menu_home.png'
import menu_news from '../menu_news.png'
import menu_kid from '../menu_kid.png'
import menu_emp from '../menu_emp.png'
import menu_calc from '../menu_calc.png'
import menu_msg from '../menu_msg.png'
import menu_raport from '../menu_raport.png'
import menu_lock from '../menu_lock.png'
import PlTitle from './PlTitle';
import Config from '../Config';
import FormatDecimal from '../helpers/FormatDecimal';


import ma_access from '../ma_access.png'
import ma_ankiety from '../ma_ankiety.png'
import ma_calc from '../ma_calc.png'
import ma_emp from '../ma_emp.png'
import ma_kids from '../ma_kids.png'
import ma_msg from '../ma_msg.png'
import ma_raporty from '../ma_raporty.png'
import ma_settings from '../ma_settings.png'
import ma_news from '../ma_news.png'


import mz_access from '../mz_access.png'
import mz_ankiety from '../mz_ankiety.png'
import mz_calc from '../mz_calc.png'
import mz_emp from '../mz_emp.png'
import mz_kids from '../mz_kids.png'
import mz_msg from '../mz_msg.png'
import mz_raporty from '../mz_raporty.png'
import mz_settings from '../mz_settings.png'
import mz_news from '../mz_news.png'

import mc_access from '../mc_access.png'
import mc_ankiety from '../mc_ankiety.png'
import mc_calc from '../mc_calc.png'
import mc_emp from '../mc_emp.png'
import mc_kids from '../mc_kids.png'
import mc_msg from '../mc_msg.png'
import mc_raporty from '../mc_raports.png'
import mc_settings from '../mc_settings.png'
import mc_news from '../mc_news.png'

import callx from '../callx.png'
import cally from '../cally.png'


function MenuLeft(props)
{
 
    
        const [menuSelected, setMenuSelected] = useState(props.mainView.menuSelected);
        const [viewSelected, setViewSelected] = useState(props.mainView.viewSelected);
        const [idSelected, setIdSelected] = useState(props.mainView.idSelected);

        const [mVisible, setMVisible] = useState(props.mainView.menuVisible);

        const [css, setCss] = useState([]);


        const showFullMenu = () => {
            props.mainView.changeMenuStatus(1);
        }

        
        if(mVisible != props.mainView.menuVisible )
        {
            setMVisible(props.mainView.menuVisible);
        }


        if(props.mainView.menuSelected != menuSelected || props.mainView.viewSelected != viewSelected || props.mainView.idSelected != idSelected)
        {
                setMenuSelected(props.mainView.menuSelected);
                setViewSelected(props.mainView.viewSelected);
                setIdSelected(props.mainView.idSelected);

                var c = new Array();
                setCss({
                    [props.mainView.menuSelected+"_"+props.mainView.viewSelected]: "selected_m",
                    [props.mainView.menuSelected]: "selected_h",
                });
        }


        if(mVisible == 0)
        {
            return null;
        }


        if(mVisible == 2) //zwinięte menu dla aplikacji mobilnej..
        {            
                return  <div className='menu_left menu_left_short' onClick={showFullMenu}>
                            <div className='btn_show_menu'> - wysuń menu główne - </div>
                       </div>
        }


        const setStyleGreen = () => { props.mainView.setStyle(1); }
        const setStyleWhite = () => { props.mainView.setStyle(2); }

       
        var new_kid_req = props.mainView.getGlobal('new_kid_req');
        var new_msg = props.mainView.getGlobal('new_msg');

       var kids = props.mainView.getGlobal('kids');

       if(new_msg != undefined &&  new_msg.length > 0)
       {
         new_msg = "(" + new_msg + ")";
       }
       

        return (
            <div className='menu_left '>
                

                <div className={'logo_view ' +  css['home']   } >
                   <img src={logob} className='logo_elizak link_normal logo_white' module="home" view="start" id="" onClick={props.mainView.quickGo} />                                
                   <img src={logo_black} className='logo_elizak link_normal logo_green' module="home" view="start" id="" onClick={props.mainView.quickGo} />                                

                   <div>
                     <PlTitle userData={props.userData} />
                    </div>

                </div>  

                
                <ul className='' >
                   
                    <li  className={ css['news']  }   module="news" view="wall" id="" onClick={props.mainView.quickGo} >
                        
                        <span className="link_normal link_head"   module="news" view="wall" id=""  mTop="1" onClick={props.mainView.quickGo} >
                            <img  className='img_ma' src={ma_news}/>
                            <img  className='img_mc' src={mc_news}/>
                            <img  className='img_mz' src={mz_news}/>
                            {props.userData.dic.menu_news}
                        </span>
                      
                        <div className={'mtitle link_normal' + ' ' + css["news_wall"] } module="news" view="wall" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mPosts}</div>
                        <div className={'mtitle link_normal' + ' ' + css["news_eat"] }  module="news" view="eat" id="" onClick={props.mainView.quickGo}  >{props.userData.dic.mEat}</div>  
                        <div className={'mtitle link_normal' + ' ' + css["news_plan"] }  module="news" view="plan" id="" onClick={props.mainView.quickGo}  >{props.userData.dic.mDayP}</div>  
                        <div className={'mtitle link_normal' + ' ' + css["news_calendar"] }  module="news" view="calendar" id="" onClick={props.mainView.quickGo}  >{props.userData.dic.mCalendar}</div>  
                        <div className={'mtitle link_normal' + ' ' + css["news_topic"] }  module="news" view="topic" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mTopics}</div>
                        <div className={'mtitle link_normal' + ' ' + css["news_query"] }  module="news" view="query" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mQuestion}</div>
                    </li>


                    <li  className={ css['kids']  }  atr-n="kids"  module="kids" view="kid" id=""   onClick={props.mainView.quickGo} >
                        <span  className='link_normal link_head' atr-n="kids"  module="kids" view="kid" id=""  mTop="1"  onClick={props.mainView.quickGo} ><img  className='img_ma' src={ma_kids}/><img  className='img_mc' src={mc_kids}/><img  className='img_mz' src={mz_kids}/>{props.userData.dic.menu_kids}</span>
                   
                        <div className={'mtitle link_normal' + ' ' + css["kids_start"] } module="kids" view="start" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mSearch}</div>
                        <div className={'mtitle link_normal' + ' ' + css["kids_group"] } module="kids" view="group" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mGroup}</div>                       
                        <div className={'mtitle link_normal' + ' ' + css["kids_kid"] } module="kids" view="kid" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mKids}</div>
                        <div className={'mtitle link_normal' + ' ' + css["calc_contract"] } module="calc" view="contract" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mContracts} <sup>({kids})</sup>  </div>
                        <div className={'mtitle link_normal' + ' ' + css["kids_free"] } module="kids" view="free" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mFree}</div>
                        <div className={'mtitle link_normal' + ' ' + css["kids_zd"] } module="kids" view="zd" id="" onClick={props.mainView.quickGo}>zaj. dodat.</div>
                        <div className={'mtitle link_normal' + ' ' + css["kids_over"] } module="kids" view="over" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mOvertime}</div>
                        <div className={'mtitle link_normal' + ' ' + css["kids_hour"] } module="kids" view="hour" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mHour}</div>
                        <div className={'mtitle link_normal' + ' ' + css["kids_inout"] } module="kids" view="inout" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mInOut}</div>                                    
                        <div className={'mtitle link_normal' + ' ' + css["kids_book"] } module="kids" view="book" id="" onClick={props.mainView.quickGo}> {props.userData.dic.mx_book}</div>                        
                        <div className={'mtitle link_normal' + ' ' + css["kids_layette"] } module="kids" view="layette" id="" onClick={props.mainView.quickGo} > wyprawka  </div>                        
                        <div className={'mtitle link_normal' + ' ' + css["kids_online"] } module="kids" view="online" id="" onClick={props.mainView.quickGo}>   {props.userData.dic.mOnline} <sup>({new_kid_req})</sup></div>                  
                    </li>

                    <li  className={ css['emps']  }    atr-n="emps"   module="emps" view="list" id=""   onClick={props.mainView.quickGo}  >
                        <span className='link_normal link_head' atr-n="emps"   module="emps" view="list" id=""  mTop="1" onClick={props.mainView.quickGo} ><img  className='img_ma' src={ma_emp}/><img  className='img_mc' src={mc_emp}/><img  className='img_mz' src={mz_emp}/>{props.userData.dic.menu_emp}</span>
                     
                        <div className={'mtitle link_normal' + ' ' + css["emps_start"] } module="emps" view="start" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mSearch}</div>
                        <div className={'mtitle link_normal' + ' ' + css["emps_list"] } module="emps" view="list" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mList}</div>
                        <div className={'mtitle link_normal' + ' ' + css["emps_schedule"] } module="emps" view="schedule" id="" onClick={props.mainView.quickGo}>grafik</div>
                        <div className={'mtitle link_normal' + ' ' + css["emps_free"] } module="emps" view="free" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mVacation}</div>
                        <div className={'mtitle link_normal' + ' ' + css["emps_over"] } module="emps" view="over" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mOvertime}</div>
                        <div className={'mtitle link_normal' + ' ' + css["emps_hour"] } module="emps" view="hour" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mHour}</div>
                        <div className={'mtitle link_normal' + ' ' + css["emps_inout"] } module="emps" view="inout" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mInOut}</div>
                        <div className={'mtitle link_normal' + ' ' + css["emps_lunch"] } module="emps" view="lunch" id="" onClick={props.mainView.quickGo}>zamówione posiłki</div>
                    </li>

                    <li  className={ css['access']  }   atr-n="access"   module="access" view="parents" id=""  onClick={props.mainView.quickGo}  >
                        <span className='link_normal link_head' atr-n="access"   module="access" view="parents" id=""  mTop="1" onClick={props.mainView.quickGo} ><img  className='img_ma' src={ma_access}/><img  className='img_mc' src={mc_access}/><img  className='img_mz' src={mz_access}/>Dostępy i uprawnienia</span>
                    
                        <div className={'mtitle link_normal' + ' ' + css["access_parents"] } module="access" view="parents" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mParents}</div>     
                        <div className={'mtitle link_normal' + ' ' + css["access_emps"] } module="access" view="emps" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mEmployees}</div>     
                        <div className={'mtitle link_normal' + ' ' + css["access_cards"] } module="access" view="cards" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mCards}</div>     
                        <div className={'mtitle link_normal' + ' ' + css["access_persons"] } module="access" view="persons" id="" onClick={props.mainView.quickGo}>odbiór dzieci</div>     
                    </li>
               

                    <li  className={ css['calc']  }    atr-n="calc"  module="calc" view="invoice" id=""   onClick={props.mainView.quickGo}  >
                        <span className='link_normal link_head' atr-n="calc"  module="calc" view="invoice" id="" mTop="1" onClick={props.mainView.quickGo}  ><img  className='img_ma' src={ma_calc}/><img  className='img_mc' src={mc_calc}/><img  className='img_mz' src={mz_calc}/>{props.userData.dic.menu_calc}</span>
                      
                        <div className={'mtitle link_normal' + ' ' + css["calc_start"] } module="calc" view="start" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mSettings}</div>
                        <div className={'mtitle link_normal' + ' ' + css["calc_contract"] } module="calc" view="contract" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mContracts} <sup>({kids})</sup>  </div>
                        <div className={'mtitle link_normal' + ' ' + css["calc_invoice"] } module="calc" view="invoice" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mInvoices}</div>
                        <div className={'mtitle link_normal' + ' ' + css["calc_transfer"] } module="calc" view="transfer" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mTransfers}</div>
                        <div className={'mtitle link_normal' + ' ' + css["calc_calculate"] } module="calc" view="calculate" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mCalculate}</div>
                        <div className={'mtitle link_normal' + ' ' + css["calc_saldo"] } module="calc" view="saldo" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mBalance}</div>
                        <div className={'mtitle link_normal' + ' ' + css["calc_saldo_sum"] } module="calc" view="saldo_sum" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mSums}</div>
                        <div className={'mtitle link_normal' + ' ' + css["calc_reqforpay"] } module="calc" view="reqforpay" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mReq}</div>
                    </li>

                    <li  className={ css['msg']  } atr-n="msg"  module="msg" view="sended" id=""  onClick={props.mainView.quickGo}   >
                        <span className='link_normal link_head' atr-n="msg"  module="msg" view="sended" id=""mTop="1"  onClick={props.mainView.quickGo} ><img  className='img_ma' src={ma_msg}/><img  className='img_mc' src={mc_msg}/><img  className='img_mz' src={mz_msg}/>{props.userData.dic.menu_msg} <sup>{new_msg}</sup> </span>
                      
                        <div className={'mtitle link_normal' + ' ' + css["msg_new"] } module="msg" view="new" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mNew}</div>
                        <div className={'mtitle link_normal' + ' ' + css["msg_sended"] } module="msg" view="sended" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mSended}</div>
                        <div className={'mtitle link_normal' + ' ' + css["msg_received"] } module="msg" view="received" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mReceived} <sup>{new_msg}</sup> </div>
                        <div className={'mtitle link_normal' + ' ' + css["msg_chat_list"] } module="msg" view="chat_list" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mContacts}</div>
                      
                    </li>


                    <li  className={ css['raport']  }  atr-n="raport"   module="raport" view="kid" id="" onClick={props.mainView.quickGo} >
                        <span className='link_normal link_head' atr-n="raport"   module="raport" view="kid" id=""  mTop="1"  onClick={props.mainView.quickGo} ><img  className='img_ma' src={ma_raporty}/><img  className='img_mc' src={mc_raporty}/><img  className='img_mz' src={mz_raporty}/>{props.userData.dic.menu_raport}</span>                     
                        <div className={'mtitle link_normal' + ' ' + css["raport_kid"] } module="raport" view="kid" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mKids}</div>
                        <div className={'mtitle link_normal' + ' ' + css["raport_list"] } module="raport" view="list" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mRaports}</div>
                    </li>

                    

                </ul>

                <div className='version_x'>

                    

                    <br/>
             
                    <span className='settings_ico'     >
                        <img  className='img_white' src={ma_settings}  module="home" view="settings" id="" onClick={props.mainView.quickGo}/>
                        <img  className='img_black' src={mc_settings}  module="home" view="settings" id="" onClick={props.mainView.quickGo} />                        
                    </span>   

                    &nbsp;
                    &nbsp;

                    <span className='settings_ico'     >
                        <img  className='img_white' src={cally}  module="home" view="support" id="" onClick={props.mainView.quickGo}/>
                        <img  className='img_black' src={callx}  module="home" view="support" id="" onClick={props.mainView.quickGo} />                        
                    </span> 

                    &nbsp;    
                   
                    &nbsp;
                    <span className='style_circle' onClick={setStyleWhite} title='Zmień style panelu'>&nbsp;</span>
                    &nbsp;&nbsp;
                    <span className='style_circle_g' onClick={setStyleGreen} title='Zmień style panelu'>&nbsp;</span>
                    &nbsp; &nbsp;                     
                    <sup>Wersja: <FormatDecimal value={Config.app_version} /> </sup>
                </div> 
           

                <br/>
                <div>
                    <a href='https://www.youtube.com/watch?v=aEbxsiyhXtg&list=PL9ZHDgSDMFZZgZkstPaxyfAccFjx1_8dS&index=8' title="Pierwsze kroki - Pokaż vodep" target='_blank' className='video_link'>Pierwsze kroki  (VIDEO)</a>
                </div>  

            </div>
        )
}


export default MenuLeft;